import React from 'react';
import '../styles/CreateContent.scss';
import CreateContent from '../components/content/CreateContent';

/**
 * The container for the Create Content flow
 */

const CreateContentContainer = () => {
  return <CreateContent />;
};

export default CreateContentContainer;
